import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ZoneEliminateIcon = withSvgIcon(
    <g>
        <path d="M441.22,473.38H37.11c-4.38,0-7.94-3.56-7.94-7.94V195.04H5.26c-2.9,0-5.26-2.36-5.26-5.25V5.25C0,2.36,2.36,0,5.26,0h184.54c2.89,0,5.25,2.36,5.25,5.25v66.13h246.17c4.38,0,7.95,3.57,7.95,7.95v386.11c0,4.38-3.57,7.94-7.95,7.94ZM39.17,463.38h400V81.38H39.17s0,382,0,382ZM10,185.04h19.17v-105.46c0-4.52,3.67-8.2,8.19-8.2h147.69V10H10v175.04Z" />
    </g>,
    "0 0 500 500"
);
